import RestClient from "@/app/shared/services/restClient";
// import store from "@/app/app-state";

class LogisticVariantStore {
  constructor(baseUrl) {
    this.logisticVariants = [];
    this.logisticVariant = null;

    this.loading = false;
    this.client = new RestClient(baseUrl);
    this.restClient = new RestClient(baseUrl).Instance;
  }

  /**
   * get all logistic variant with paginate
   * @param {*} query
   */
  async postFilters(query) {
    this.loading = true;

    let response = await this.restClient.post("/LogisticsVariants/Query", query);
    let data = response.data;
    let itemsCount = response.headers["content-range"].split("/")[1];

    this.loading = false;

    return { data, itemsCount };
  }

  /**
   * get logistic variant with Id
   * @param {*} logisticVariantId
   */
  async getlogisticVariant(logisticVariantId) {
    let response = await this.restClient.get("/LogisticsVariants/" + logisticVariantId);
    this.logisticVariant = response.data;

    return this.logisticVariant;
  }

  /**
   * call methode to block or unblock vl
   * @param {*} logisticVariantId
   * @param {*} blockingType
   * @param {*} parcelNumber
   * @param {*} csuNumber
   * @param {*} netWeight
   */
  async postBlockUnblocklogisticVariant(logisticVariantId, blockingType, parcelNumber, csuNumber, netWeight) {
    this.loading = true;
    let typeBlocage = "";
    switch (blockingType) {
      case "B":
        typeBlocage = "Block";
        break;
      case "D":
        typeBlocage = "Unblock";
        break;
      default:
        break;
    }

    let response;

    if (typeBlocage != "") {
      this.client.handleError = false;
      response = await this.restClient.post("/LogisticsVariants/" + logisticVariantId + "/" + typeBlocage, {
        logisticVariantId: logisticVariantId,
        parcelNumber: parcelNumber != "" ? parcelNumber : 0,
        csuNumber: csuNumber != "" ? csuNumber : 0,
        netWeight: netWeight != "" ? netWeight : 0
      });
    }
    this.loading = false;
    return response;
  }

  /**
   * call methode to get UVC and net weight
   * @param {*} logisticVariantId
   * @param {*} nbColis
   */
  async getCalculateUVCAndNetWeight(logisticVariantId, nbColis) {
    this.loading = true;

    let response = await this.restClient.post("/LogisticsVariants/" + logisticVariantId + "/Quantity", {
      logisticVariantID: logisticVariantId,
      parcelNumber: nbColis
    });

    let data = response.data;

    this.loading = false;

    return { data };
  }

  /**
   * Get the list of eligible contractors
   * @param {*} query
   */
  async getDataSuggest(query) {
    query = query ? "?q=" + query : "";
    let response = await this.restClient.get("/Contractors/Suggests" + query);
    let data = response.data;
    return data;
  }
}
export default LogisticVariantStore;
